import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "d-grid gap-3 mt-3 mb-3",
  id: "comments"
}
const _hoisted_2 = {
  key: 0,
  class: "bg-white"
}

import {useAuditCommentStore} from "@/stores/auditCommentStore";
import {computed, ref} from "vue";
import {object, string} from "yup";
import TextareaInput from "../Fields/TextareaInput.vue";
import LoadingSpinner from "../Misc/LoadingSpinner.vue";
import {Audit, AuditComment, FormValidation} from "@/audit.types";
import {debounce} from "vue-debounce";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetailsComments',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

var updateData = debounce(() => getData(), "15000ms");

const props = __props;

const errors = ref<FormValidation>({} as FormValidation);
const canAddComment = computed(() => props.audit.status != "Closed");
const auditCommentStore = useAuditCommentStore();

const getData = async function () {
	await auditCommentStore.list(props.id);
	await updateData();
};
const comment = ref({} as AuditComment);

const schema = object<AuditComment>({
	content: string().required().label("Comment"),
});

const addComment = async function () {
	errors.value = {} as FormValidation;

	schema
		.validate(comment.value, {abortEarly: false})
		.then(async () => {
			comment.value.auditId = props.id;
			await auditCommentStore.create(comment.value);
			await auditCommentStore.list(props.id);
			comment.value = {} as AuditComment;
		})
		.catch((err) => {
			err.inner.forEach((error) => {
				errors.value = {...errors.value, [error.path]: error.message};
			});
		});
};

;(
  ([__temp,__restore] = _withAsyncContext(() => getData())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (canAddComment.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(addComment, ["prevent"])
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("label", {
              for: "comment",
              class: "form-label"
            }, "Comment ", -1)),
            _createVNode(TextareaInput, {
              name: "comment",
              type: "text",
              modelValue: comment.value.content,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment.value.content) = $event)),
              error: errors.value.content
            }, null, 8, ["modelValue", "error"]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mt-3 d-grid gap-2 d-md-flex justify-content-md-end" }, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "submit"
              }, " Add ")
            ], -1))
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auditCommentStore).items.data, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "p-2 mb-3 bg-light border",
        key: item.id
      }, [
        _createElementVNode("strong", null, _toDisplayString(item.createdBy), 1),
        _createTextVNode(" - " + _toDisplayString(item.createdOn) + " ", 1),
        _createElementVNode("div", null, _toDisplayString(item.content), 1)
      ]))
    }), 128)),
    _createVNode(LoadingSpinner, {
      "show-loading": _unref(auditCommentStore).loading
    }, null, 8, ["show-loading"])
  ]))
}
}

})